import React from "react";
import { FaWallet } from "react-icons/fa";
import CountUp from "react-countup";

const EWallet = ({ title, icon, amount }) => {
  return (
    <>
      {/* <div className="col-sm-12 col-md-6 col-lg-3"> */}

      <div
        className={`mb-3 ${
          title === "E-Wallet"
            ? "col-sm-12  col-md-6 col-lg-3 "
            : "col-sm-6 col-md-4 col-lg-2 card-pay "
        } `}
      >
        <div
          className={`card    ${title === "E-Wallet" ? "e-wallet" : "e-pay"} `}
        >
          <div className="d-flex justify-content-between  align-items-center px-4 p-3">
            <div className="total-income">
              <b>{title}</b>
              <h3 className="fw-bold">
                $ <CountUp end={amount === 0 ? "0" : amount} duration={0.5} />
              </h3>
            </div>
            <div className="dollar fw-bold">
              {title !== "E-Wallet" ? (
                <h3 className="text fw-bold">$ </h3>
              ) : (
                <h3 className="e-wallet-co">
                  <FaWallet size={60} />
                </h3>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EWallet;
